/**
 * Property Manager Profile API
 * PM profile CRUD, invite-code resolution, and directory (published PMs).
 */

import { apiTransport as router } from './transport';
import { getContext } from './core';

export interface PmProfileRow {
  id: string;
  userId: string;
  companyName: string;
  dba?: string | null;
  brokerLicenseNumber?: string | null;
  licenseState?: string | null;
  licenseExpiration?: string | null;
  status: string;
  inviteCode?: string | null;
  eoPolicyNumber?: string | null;
  eoCarrier?: string | null;
  eoExpiry?: string | null;
  createdAt: string;
  updatedAt: string;
  user?: { id: string; fullName: string; email: string };
}

export type PmProfileCreateBody = {
  companyName: string;
  dba?: string | null;
  brokerLicenseNumber?: string | null;
  licenseState?: string | null;
  licenseExpiration?: string | null;
  status?: string;
  eoPolicyNumber?: string | null;
  eoCarrier?: string | null;
  eoExpiry?: string | null;
};

export const pmProfileApi = {
  get: async (): Promise<PmProfileRow | null> => {
    const context = getContext();
    return router.get<PmProfileRow | null>('/pm-profile', context);
  },

  getByInviteCode: async (inviteCode: string): Promise<PmProfileRow | null> => {
    return router.get<PmProfileRow | null>(`/pm-profile/by-invite-code/${encodeURIComponent(inviteCode.trim())}`);
  },

  listPublished: async (): Promise<PmProfileRow[]> => {
    return router.get<PmProfileRow[]>('/pm-profiles');
  },

  create: async (body: PmProfileCreateBody): Promise<PmProfileRow> => {
    const context = getContext();
    return router.post<PmProfileRow>('/pm-profile', body, context);
  },

  update: async (body: Partial<PmProfileCreateBody>): Promise<PmProfileRow> => {
    const context = getContext();
    return router.patch<PmProfileRow>('/pm-profile', body, context);
  },
};
